import { render, staticRenderFns } from "./BeneficiaryInfo.vue?vue&type=template&id=e27a17ae&scoped=true"
import script from "./BeneficiaryInfo.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInfo.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryInfo.vue?vue&type=style&index=0&id=e27a17ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27a17ae",
  null
  
)

export default component.exports